/**
 * src/hooks/useOnboarding.js
 */
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOnboardingInfo,
  submitOnboardingProfile,
  submitOnboardingDocuments,
  submitOnboardingPassword,
  setOnboardingToken,
  clearOnboardingErrors,
  resetOnboarding,
} from "../store/slices/onboardingSlice";

const useOnboarding = () => {
  const dispatch = useDispatch();

  const {
    token,
    email,
    role,
    requiresDocuments,
    onboardingStep,
    onboardedUser,
    isLoadingInfo,
    isSubmittingProfile,
    isSubmittingDocuments,
    isSubmittingPassword,
    infoError,
    profileError,
    documentsError,
    passwordError,
    profileSuccess,
    documentsSuccess,
    passwordSuccess,
  } = useSelector((state) => state.onboarding);

  return {
    // ── State ──────────────────────────────
    token,
    email,
    role,
    requiresDocuments,
    onboardingStep,
    onboardedUser,

    // ── Loading ────────────────────────────
    isLoadingInfo,
    isSubmittingProfile,
    isSubmittingDocuments,
    isSubmittingPassword,

    // ── Errors ─────────────────────────────
    infoError,
    profileError,
    documentsError,
    passwordError,

    // ── Success ────────────────────────────
    profileSuccess,
    documentsSuccess,
    passwordSuccess,

    // ── Actions ────────────────────────────
    storeToken: (token) => dispatch(setOnboardingToken(token)),
    loadInfo: (token) => dispatch(fetchOnboardingInfo(token)),
    submitProfile: (data) => dispatch(submitOnboardingProfile(data)),
    submitDocuments: (formData) =>
      dispatch(submitOnboardingDocuments(formData)),
    // unwrap(): a rejected request must throw. Without it dispatch resolves
    // either way, and the form showed "Congrats" even when the server had
    // refused to save the password.
    submitPassword: (token, password) =>
      dispatch(submitOnboardingPassword({ token, password })).unwrap(),
    clearErrors: () => dispatch(clearOnboardingErrors()),
    reset: () => dispatch(resetOnboarding()),
  };
};

export default useOnboarding;
